export const API_HOST = process.env.REACT_APP_BACKEND;
export const MESSAGE_IMAGE_PATH_ADMIN =
  process.env.REACT_APP_MESSAGE_IMAGE_PATH_ADMIN;
export const MESSAGE_IMAGE_PATH_USER =
  process.env.REACT_APP_MESSAGE_IMAGE_PATH_USER;
export const REACT_APP_API_KEY = process.env.REACT_APP_API_KEY;
export const PHOTREAM_APP = process.env.REACT_APP_PHOTREAM_APP;
